<template lang="pug">
div
  el-form-item(label="选择层级")
    el-select(v-model="showLevel", @change="levelChange")
      el-option(v-for="{ cnName, id } in levels", :key="id", :value="id", :label="cnName")
  el-form-item(label="默认值")
    city-input.width-full(:key="showLevel", v-model="defaultCity", :level="showLevel")
  el-divider 显示字段
  field-setting(v-bind="$props", v-model="assignToName", label="关联显示字段")
</template>
<script>
import { mapVFOptions, settingMixin } from "@/CommonDP/VForm/utils";
import { levels } from "./index.js";
import CityInput from "./input";

export default {
  components: { CityInput },
  mixins: [settingMixin],
  data() {
    return {
      levels: levels
    };
  },
  computed: {
    ...mapVFOptions(["showLevel", "assignToName", "defaultCity"])
  },
  methods: {
    levelChange() {
      this.defaultCity = "";
    }
  }
};
</script>
<style lang="scss" scoped src="./index.scss"></style>
